// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"270":"267ada27","471":"ea64ea4f","561":"0d752158","686":"d626ece2","987":"400a9fcd"}[chunkId] + ".js";
};